import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import { Content } from '../../../Content';
import React from 'react';
import { constructContent } from '../../../ContentDispatcher';

const styles = createStyles({
  dialogPaper: {
    height: 'calc(100% - 64px)',
  },
  dialogContent: {
    height: 'calc(100% - 80px)',
  },
});
interface ContentPopupProps extends WithStyles<typeof styles> {
  content: Content;
  onCloseRequested: () => void;
}

const ContentPopup: React.FC<ContentPopupProps> = ({
  content,
  classes,
  ...props
}) => {
  return (
    <Dialog
      open={true}
      scroll="body"
      onClose={props.onCloseRequested}
      fullWidth={true}
      maxWidth={content.dialogOptions?.maxWidth ?? 'lg'}
      classes={
        content.dialogOptions?.fullHeight
          ? { paper: classes.dialogPaper }
          : undefined
      }
    >
      {content?.title && <DialogTitle>{content.title}</DialogTitle>}
      <DialogContent
        classes={
          content.dialogOptions?.fullHeight
            ? { root: classes.dialogContent }
            : undefined
        }
      >
        <div className="popup-body" style={{ height: '100%' }}>
          {constructContent(content)}
        </div>
      </DialogContent>
      <DialogActions>
        <Grid justify="flex-start" container spacing={2}>
          {content.links?.map(({ text, href }) => (
            <Grid item key={text}>
              <Button onClick={() => window.open(href)}>{text}</Button>
            </Grid>
          ))}
        </Grid>
        <Button onClick={props.onCloseRequested}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
export default withStyles(styles)(ContentPopup);
